import { combineReducers, configureStore } from '@reduxjs/toolkit'
import authSlice from './services/authSlice'
import classesSlice from './services/classesSlice'
import contestSlice from './services/contestSlice'
import balanceSlice from './services/balanceSlice'
import kycSlice from './services/kycSlice'
import qaSlice from './services/qaSlice'
import reportSlice from './services/reportSlice'
import feedbackSlice from './services/feedbackSlice'

const combineReducer = combineReducers({
    auth: authSlice,
    classes: classesSlice,
    contest: contestSlice,
    balance: balanceSlice,
    kyc: kycSlice,
    qa: qaSlice,
    report: reportSlice,
    feedback: feedbackSlice,
})

const store = configureStore({
    reducer: combineReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
})

export default store